import type { ReactNode } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../lib/auth';

interface AppShellProps {
  children: ReactNode;
}

export function AppShell({ children }: AppShellProps) {
  const { logout } = useAuth();
  const location = useLocation();

  return (
    <div className="min-h-screen flex flex-col bg-white text-black">
      <header className="border-b border-border-light bg-white">
        <div className="max-w-[1200px] mx-auto px-6 h-14 flex items-center justify-between gap-8">
          <div className="flex items-center gap-8">
            <NavLink to="/" className="flex items-baseline gap-2 group">
              <span className="mono-label text-black tracking-[0.12em]">time</span>
              <span className="font-display text-[18px] font-medium tracking-[-0.02em] text-midnight">
                tracker
              </span>
            </NavLink>

            <nav className="flex items-center gap-6">
              <NavLink
                to="/"
                end
                className={({ isActive }) =>
                  `font-display text-body transition-colors ${
                    isActive || location.pathname.startsWith('/projects/')
                      ? 'text-black font-medium'
                      : 'text-black/50 hover:text-black'
                  }`
                }
              >
                Projects
              </NavLink>
              <NavLink
                to="/settings"
                className={({ isActive }) =>
                  `font-display text-body transition-colors ${
                    isActive ? 'text-black font-medium' : 'text-black/50 hover:text-black'
                  }`
                }
              >
                Settings
              </NavLink>
            </nav>
          </div>

          <button type="button" onClick={logout} className="btn-secondary !py-1.5 !px-3">
            <span className="mono-label">Log out</span>
          </button>
        </div>
      </header>

      <main className="flex-1">
        <div className="max-w-[1200px] mx-auto px-6 py-10">{children}</div>
      </main>

      <footer className="border-t border-border-light">
        <div className="max-w-[1200px] mx-auto px-6 py-4 flex items-center justify-between">
          <span className="mono-label text-black/50">synced via cloudflare</span>
          <span className="mono-label text-black/50">v0.1.0</span>
        </div>
      </footer>
    </div>
  );
}
